<app-base-operator-seasons-compare-statistics
[title]="title"
[getMonthlyItemsApiMethodName]="getMonthlyItemsApiMethodName"
[getDailyItemsApiMethodName]="getDailyItemsApiMethodName"
[isShowOrganizationDropDown]="false"
[isShowUserDropDown]="false"
[doughnutChartId]="doughnutChartId"
[barChartId]="barChartId"
statisticalReportsCompareType="superAdmin"
>
</app-base-operator-seasons-compare-statistics>
